module.exports = __webpack_public_path__ + "static/media/who.25844a04.jpg";